import logo from 'images/stm-logo-white.png';


import * as S from './styles';

function Nav() {
  return (
    <S.Wrapper>
      <a href="https://stmforum.com/" target="blank">
        <img src={logo} alt="" />
      </a>
      <ul>
        <li><a href="https://stmforum.com/" target="blank">what’s stm forum?</a></li>
        <li><a href="mailto:info@stmforum.com"  target="blank">info@stmforum.com</a></li>
        <li className="login-link"  target="blank"><a href="https://stmforum.com/amember/protect/new-rewrite?f=2&url=/forum/&host=stmforum.com&ssl=on">login</a></li>
      </ul>
    </S.Wrapper>
  );
}

export default Nav;
